import { Button } from "../../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../../components/generic/ListPicker";
import { usePickerhook } from "../../../../hooks/usePickerhook";
import { SearchBar } from "../../../../components/generic/SearchBar";
import { useEffect, useState } from "react";
import { useDeptHook } from "../../../../hooks/useDeptHook";
import { NoEmployee } from "../../../../components/users/NoEmployee";
import AddEmployee from "../../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "../EmployeeItem";
import useDepartmentHook from "../../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../../hooks/useEmployeeHook";
import AddPosition from "../../../../components/Modules/Employees/AddPositionModal";
import usePositionHook from "../../../../hooks/usePositionHook";
import AddPositionModal from "../../../../components/Modules/Employees/AddPositionModal";
import PositionItem from "../PositionItem";
import LeaveTypeListing from "./LeaveTypeListing";
import AddLeaveTypeModal from "../../../../components/Modules/Employees/AddLeaveTypeModal";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PolicyListing from "./PolicyListing";
import AddLeavePolicy from "../../../../components/Modules/Employees/AddLeavePolicy";

export default () => {
  const departmentPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const [showadddept, setshowadddept] = useState(false);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { selectedOrgDepts } = useDepartmentHook();
  const [entered, setentered] = useState("");
  const { OrgLeaveTypes,OrgLeavePolicies, getOrgLeavePolicies, getOrgLeaveTypes } = useLeaveHook();

  const tabs = ["Types", "Policy"];
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const [selectedTab, setselectedTab] = useState(tabs[0]);
  const [showaddleavepolicy, setshowaddleavepolicy] =useState(false)

  const tabViews =  [<LeaveTypeListing  refresh={getOrgLeaveTypes}  leaves={OrgLeaveTypes} setshowadddept={setshowadddept}/>, <PolicyListing  refresh ={getOrgLeavePolicies } OrgLeavePolicies={OrgLeavePolicies} setshowaddleavepolicy={setshowaddleavepolicy}/>];

  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );

  const ActionItem2 = ({ title }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[tabs.indexOf(title)]);
        setselectedTab(title);
      }}
      className={` m-2 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{title}</p>
    </div>
  );

  useEffect(()=>{

    setselectedTabview(tabViews[0]);
    setselectedTab(tabs[0]);
  },[OrgLeavePolicies,OrgLeaveTypes])
  
  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && (
        <AddLeaveTypeModal
          AddPosition={AddPosition}
          allorgPositions={allorgPositions}
          refresh={getOrgLeaveTypes}
          show={setshowadddept}
        />
      )}
      {showaddleavepolicy && (
        <AddLeavePolicy
        
          AddPosition={AddPosition}
          allorgPositions={allorgPositions}
          refresh={getOrgLeavePolicies}
          show={setshowaddleavepolicy}
        />
      )}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="flex  my-3">
          {tabs.map((item) => (
            <ActionItem2 title={item} />
          ))}
        </div>
        <div className="  w-full  flex justify-between items-center  ">
       <p></p>

       
        </div>

     

        {selectedTabview}
      </div>
    </div>
  );
};
